import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col, Tabs, Tab } from "react-bootstrap";

import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import moment from "moment";
import { adminAction } from '../Api';

const MRModal = ({ show, onHide, match }) => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [activeTab, setActiveTab] = useState("match_report");
  const [checkedMembers, setCheckedMembers] = useState({});
  const [actionModal, setActionModal] = useState({
    show: false,
    type: "", // "warning" or "ban"
    selectedUsers: [],
    reason: "",
  });

  useEffect(() => {
    setSelectedUser(null);
    setActiveTab("match_report");
    setCheckedMembers({});
  }, [match]);

  const reports = match?.reports?.[activeTab] || [];
  const uniqueReporters = [...new Set(reports.map((r) => r.reporter))];
  const filteredReports =
    selectedUser === "Select All" || !selectedUser
      ? reports
      : reports.filter((r) => r.reporter === selectedUser);

  const handleClose = () => {
    setActiveTab("match_report");
    setSelectedUser(null);
    setCheckedMembers({});
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      {/* Modal Header */}
      <Modal.Header
        closeButton
        style={{

          borderTopLeftRadius: "0.5rem",
          borderTopRightRadius: "0.5rem",
          boxShadow: "0 2px 8px rgba(212,69,27,0.10)",
          borderBottom: "3px solid #fff",
        }}
      >
        <Modal.Title>
          Reports for {match?.sport_name} (ID: {match?.match_history_id})
        </Modal.Title>
      </Modal.Header>

      {/* Modal Body */}
      <Modal.Body
        style={{
          background: "#fff",
          color: "#111",
          minHeight: 350,
        }}
      >
        <Tabs
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className="mb-3 justify-content-center"
        >
          <Tab eventKey="match_report" title="Match Reports" />
          <Tab eventKey="user_report" title="User Reports" />
          <Tab eventKey="members" title="Members" />
        </Tabs>

        <Row>
          {/* Left column for report tabs */}
          {activeTab !== "members" && (
            <Col md={4}>
              <div className="p-3 border rounded bg-light mb-3">
                <Form>
                  <Form.Check
                    type="radio"
                    label={<span className="fw-bold">Select All</span>}
                    value="Select All"
                    checked={selectedUser === "Select All"}
                    onChange={(e) => setSelectedUser(e.target.value)}
                  />
                  {uniqueReporters.map((user) => (
                    <Form.Check
                      key={user}
                      type="radio"
                      label={<span className="text-primary">{user}</span>}
                      value={user}
                      checked={selectedUser === user}
                      onChange={(e) => setSelectedUser(e.target.value)}
                    />
                  ))}
                </Form>
              </div>
            </Col>
          )}

          {/* Right column */}
          <Col md={activeTab === "members" ? 12 : 8}>
            {activeTab === "members" ? (
              match?.members?.length === 0 ? (
                <div className="alert alert-secondary">No members available</div>
              ) : (
                <>
                  {(() => {
                    const selectedCount = Object.values(checkedMembers).filter(Boolean).length;
                    const selectedMembers = match.members.filter((m) => checkedMembers[m.user_id]);
                    return (
                      <>
                        {/* Bulk action buttons for multiple selection */}
                        {selectedCount > 1 && (
                          <div className="mb-3 d-flex gap-2">
                            <Button
                              variant="warning"
                              onClick={() =>
                                setActionModal({
                                  show: true,
                                  type: "warn",
                                  match_id: match.match_history_id,
                                  selectedUsers: selectedMembers,
                                  reason: "",
                                })
                              }
                            >
                              Send Warning
                            </Button>
                            <Button
                              variant="danger"
                              onClick={() =>
                                setActionModal({
                                  show: true,
                                  type: "ban",
                                  match_id: match.match_history_id,
                                  selectedUsers: selectedMembers,
                                  reason: "",
                                })
                              }
                            >
                              Ban
                            </Button>
                          </div>
                        )}

                        {/* Members list */}
                        <div className="row g-2">
                          {match.members.map((m) => {
                            const isChecked = checkedMembers[m.user_id] || false;
                            const singleSelected = selectedCount === 1 && isChecked;

                            return (
                              <div
                                key={m.user_id}
                                className={`col-12`}
                                onClick={() =>
                                  setCheckedMembers((prev) => ({
                                    ...prev,
                                    [m.user_id]: !prev[m.user_id],
                                  }))
                                }
                                style={{
                                  background: isChecked ? "#f8f9fa" : "#fff",
                                  border: isChecked
                                    ? "2px solid #FFD700"
                                    : "1px solid #e9ecef",
                                  borderRadius: "8px",
                                  padding: "12px",
                                  marginBottom: "6px",
                                  cursor: "pointer",
                                  boxShadow: isChecked
                                    ? "0 0 0 2px #ffe066"
                                    : "none",
                                  transition: "background 0.2s, border 0.2s, box-shadow 0.2s",
                                }}
                              >
                                <div className="d-flex align-items-center">
                                  <span
                                    style={{
                                      width: "18px",
                                      height: "18px",
                                      border: "1.5px solid #333",
                                      borderRadius: "3px",
                                      marginRight: "12px",
                                      display: "inline-block",
                                      position: "relative",
                                      background: isChecked ? "#FFD700" : "#fff",
                                    }}
                                  >
                                    {isChecked && (
                                      <span
                                        style={{
                                          position: "absolute",
                                          top: "2px",
                                          left: "5px",
                                          width: "5px",
                                          height: "10px",
                                          border: "solid #333",
                                          borderWidth: "0 2px 2px 0",
                                          transform: "rotate(45deg)",
                                        }}
                                      />
                                    )}
                                  </span>
                                  <div>
                                    <span className="fw-bold">{m.full_name}</span>{" "}
                                    <span className="badge bg-secondary ms-1">
                                      ID: {m.user_id}
                                    </span>
                                  </div>
                                </div>

                                {/* Embedded buttons for single selection */}
                                {singleSelected && (
                                  <div className="mt-2">
                                    <Button
                                      variant="warning"
                                      size="sm"
                                      className="me-2"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setActionModal({
                                          show: true,
                                          type: "warn",
                                          match_id: match.match_history_id,
                                          selectedUsers: [m],
                                          reason: "",
                                        });
                                      }}
                                    >
                                      Send Warning
                                    </Button>
                                    <Button
                                      variant="danger"
                                      size="sm"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setActionModal({
                                          show: true,
                                          type: "ban",
                                          match_id: match.match_history_id,
                                          selectedUsers: [m],
                                          reason: "",
                                        });
                                      }}
                                    >
                                      Ban
                                    </Button>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </>
                    );
                  })()}
                </>
              )
            ) : filteredReports.length === 0 ? (
              <div className="alert alert-secondary">No reports available</div>
            ) : (
              <div className="d-flex flex-column gap-3">
                {filteredReports.map((r, i) => (
                  <div
                    key={i}
                    className="border rounded p-3 bg-light"
                    style={{
                      borderLeft: "5px solid #FF9B45",
                    }}
                  >
                    <div className="d-flex align-items-center mb-2">
                      <span className="fw-bold me-2">{r.reporter}</span>
                      {activeTab === "user_report" && (
                        <span className="badge bg-info text-dark">
                          Reported: {r.reported_user}
                        </span>
                      )}
                    </div>
                    <hr style={{ margin: "8px 0", borderTop: "1px solid #bbb" }} />
                    <div style={{ whiteSpace: "pre-line" }}>{r.content}</div>
                  </div>
                ))}
              </div>
            )}
          </Col>
        </Row>
      </Modal.Body>

      {/* Action Modal */}
      <Modal
        show={actionModal.show}
        onHide={() => setActionModal({ ...actionModal, show: false })}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {actionModal.type === "warn" ? "Send Warning" : "Ban User"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            background: "#fff",
            color: "#111",
          }}
        >
          <p>Match ID: {actionModal.match_id}</p>
          {actionModal.selectedUsers?.length ? (
            actionModal.selectedUsers.length > 1 ? (
              <>
                <p>Selected Users:</p>
                <ul>
                  {actionModal.selectedUsers.map((u) => (
                    <li key={u.user_id}>
                      {u.full_name} (ID: {u.user_id})
                    </li>
                  ))}
                </ul>
              </>
            ) : (
              <p>
                {actionModal.selectedUsers[0].full_name} (ID: {actionModal.selectedUsers[0].user_id})
              </p>
            )
          ) : (
            <p>No users selected</p>
          )}



          {/* 🔹 Ban Until Picker */}
          {actionModal.type === "ban" && (
            <div className="mb-3">
              <label className="form-label">Ban Until</label>
              <Datetime
                value={actionModal.banUntil ? moment(actionModal.banUntil) : null}
                onChange={(val) => {
                  if (moment.isMoment(val) && val.isValid()) {
                    setActionModal(prev => ({ ...prev, banUntil: val }));
                  } else {
                    setActionModal(prev => ({ ...prev, banUntil: null }));
                  }
                }}
                dateFormat="YYYY-MM-DD"
                timeFormat="HH:mm"
                input={false}
                closeOnSelect={false}
                isValidDate={(current) => current.isSameOrAfter(moment(), "day")}
                timeConstraints={{
                  hours: { min: (date) => (moment(date).isSame(moment(), "day") ? moment().hour() : 0) },
                  minutes: { min: (date) => (moment(date).isSame(moment(), "day") ? moment().minute() : 0) },
                }}
              />
              {actionModal.banUntil && (
                <div className="mt-2 text-muted">
                  Selected: <strong>{new Date(actionModal.banUntil).toLocaleString()}</strong>
                </div>
              )}
            </div>
          )}

          <label className="form-label">Reason</label>
          <Form.Control
            as="textarea"
            rows={2}
            value={actionModal.reason}
            onChange={(e) => setActionModal(prev => ({ ...prev, reason: e.target.value }))}
          />






        </Modal.Body>
        <Modal.Footer
          style={{
            background: "#fff",
            color: "#111",
          }}
        >
          <Button
            variant="secondary"
            onClick={() => setActionModal({ ...actionModal, show: false })}
          >
            Close
          </Button>
          <Button
            variant={actionModal.type === "warn" ? "warning" : "danger"}
            onClick={async () => {
              try {
                // Collect all selected user IDs
                const userIds = actionModal.selectedUsers.map(u => u.user_id);

                // Call adminAction once for all selected users
                await adminAction({
                  target_user_ids: userIds,
                  action_type: actionModal.type,
                  reason: actionModal.reason,
                  ban_expires_at:
                    actionModal.type === "ban" && actionModal.banUntil
                      ? new Date(actionModal.banUntil).toISOString()
                      : null,
                });

                // Reset modal and selections
                setCheckedMembers({});
                setActionModal({ ...actionModal, show: false, banUntil: null });
              } catch (error) {
                console.error("Error performing admin action:", error);
              }
            }}
            disabled={actionModal.type === "ban" && !actionModal.banUntil}
          >
            {actionModal.type === "warn" ? "Send Warning" : "Ban"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal.Footer
        style={{
          background: "#fff",
          color: "#111",
        }}
      >
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>


  );


};

export default MRModal;
